<template>
  <v-app>
    <Navbar/>
    <v-content>
      <form @submit.prevent="addNewItemCategory">
        <v-card>
          <v-container grid-list-sm class="pa-4 add_item_category_vue">
            <v-layout row wrap>
              <v-flex xs12 align-center justify-space-between>
                <v-layout align-center>
                  <v-text-field
                    prepend-icon="shopping_cart"
                    placeholder="Category Name"
                    required
                    v-model="category_name"
                  ></v-text-field>
                </v-layout>
              </v-flex>

              <v-flex xs12 align-center justify-space-between>               
                <h3>Lataa luokan kuva</h3>
                <v-layout align-center>                                   
                  <input type="file" @change="uploadImage"/>                   
                </v-layout>
                <v-progress-linear
                  :active="loading"
                  :indeterminate="loading"                   
                  color="#345B2C"
                ></v-progress-linear>               
              </v-flex>
          
              <v-flex xs12>
                <v-btn type="submit" class="main_color" block dark>lisää Luokka</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </form>
    </v-content>
  </v-app>
</template>

<script>
  import Navbar from '@/components/admin/navbar/Navbar'
  import firebase from "firebase";
  import moment from 'moment'
  export default {
    name:'AddItemCategory',
    components:{
      Navbar
    },
    data(){
      return{
        dialog:null,
        category_name:null,
        image:null,
        timestamp:null,
        loading: null,
        feedback:null,
      }
    },
    watch: {
      loading (val) {
        if (!val) return
        setTimeout(() => (this.loading = false), 4000)
      },
    }, 
    methods:{
      addNewItemCategory(){
        var db = firebase.firestore();
        if(this.category_name){
        let ref = db.collection('category');
          ref.doc(this.$route.params.id).update({          
            note:this.image,
            name:this.category_name
          })
          this.category_name=null
          this.category_icon=null
        }
        this.$router.push({ name: 'ItemCategories'})
      },
    
      uploadImage(e){
        if(e.target.files[0]){
          
            let file = e.target.files[0];
      
            var storageRef = firebase.storage().ref('product-category/'+ Math.random() + '_'  + file.name);
      
            let uploadTask  = storageRef.put(file);
      
            uploadTask.on('state_changed', (snapshot) => {
              
            }, (error) => {
              // Handle unsuccessful uploads
            }, () => {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                this.image=downloadURL;
                console.log(downloadURL);                
              });
            }); 
            this.loading = true            
        }
      }  
    },
    created(){
 var db = firebase.firestore();
      db.collection("category").doc(this.$route.params.id).onSnapshot(doc =>{
         this.image=doc.data().note,
         this.category_name=doc.data().name

             console.log("image: "+ doc.data().note);
    })


    }
  }
</script>

<style>
.primary--text {
    color: #345B2C !important;
    caret-color: #345B2C !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/stock/AddItemCategory.vue